import React from "react";
import "./WelocateAreaFilter.css";

const OPTIONS = [
  { label: "Any", value: null },
  { label: "40+ m²", value: 40 },
  { label: "60+ m²", value: 60 },
  { label: "80+ m²", value: 80 },
  { label: "100+ m²", value: 100 },
  { label: "150+ m²", value: 150 },
];

const WelocateAreaFilter = ({ selected, onSelect }) => (
  <div className="wl-area-filter">
    {OPTIONS.map(({ label, value }) => {
      const isSelected = selected === value;
      return (
        <button
          key={label}
          className={`wl-area-filter__option${isSelected ? " wl-area-filter__option--selected" : ""}`}
          onClick={() => onSelect(value)}
        >
          {label}
        </button>
      );
    })}
  </div>
);

export default WelocateAreaFilter;
